import * as React from "react";

import { IconProps } from "./types";

const DotIcon = ({
  className,
  width = 24,
  height = 24,
  strokeWidth = 2,
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      strokeWidth={strokeWidth}
      className={className}
    >
      <circle cx={12} cy={12} r={11} />
    </svg>
  );
};

export default DotIcon;
